/** Native Shopify bundle selector. Recipes contain real parent variants with component relationships. */
class BmsBundleBuilder extends HTMLElement {
  connectedCallback() {
    this.onPageShow ||= event => {
      if (!event.persisted || !this.ready) return;
      this.busy = false;
      this.status.textContent = '';
      this.render();
    };
    window.addEventListener('pageshow', this.onPageShow);
    if (this.ready) return;
    this.ready = true;
    this.inputs = [...this.querySelectorAll('[data-quantity]')];
    this.count = Number(this.dataset.count);
    this.status = this.querySelector('[data-status]');
    this.button = this.querySelector('[data-submit]');
    this.form = this.querySelector('form');
    this.map = JSON.parse(this.querySelector('[data-recipes]').textContent);
    this.addEventListener('click', event => {
      const step = event.target.closest('[data-step]');
      if (!step || this.busy) return;
      const field = this.inputs[Number(step.dataset.index)];
      const remaining = this.count - this.total();
      field.value = Math.max(0, Number(field.value) + (Number(step.dataset.step) > 0 ? Math.min(1, remaining) : -1));
      this.render();
    });
    this.addEventListener('input', event => {
      if (!event.target.matches('[data-quantity]')) return;
      const field = event.target;
      const others = this.inputs.filter(x => x !== field).reduce((n,x) => n + Number(x.value || 0), 0);
      field.value = Math.min(this.count - others, Math.max(0, Math.trunc(Number(field.value) || 0)));
      this.render();
    });
    this.form.addEventListener('submit', event => { event.preventDefault(); this.submit(); });
    this.render();
  }
  disconnectedCallback() {
    window.removeEventListener('pageshow', this.onPageShow);
  }
  total() { return this.inputs.reduce((n, input) => n + Number(input.value || 0), 0); }
  render() {
    const total = this.total();
    this.form.setAttribute('aria-busy', String(!!this.busy));
    this.querySelector('[data-progress]').textContent = `${total} of ${this.count} bars selected`;
    this.querySelector('progress').value = total;
    this.inputs.forEach((input, i) => {
      this.querySelector(`[data-index="${i}"][data-step="-1"]`).disabled = this.busy || Number(input.value) === 0;
      this.querySelector(`[data-index="${i}"][data-step="1"]`).disabled = this.busy || total === this.count;
      input.disabled = !!this.busy;
      input.max = String(Number(input.value || 0) + this.count - total);
    });
    this.button.disabled = !!this.busy || total !== this.count || this.dataset.enabled !== 'true';
    this.button.textContent = this.busy ? 'ADDING…' : total !== this.count ? `CHOOSE ${this.count - total} MORE ${this.count - total === 1 ? 'BAR' : 'BARS'}` : this.dataset.enabled === 'true' ? `ADD BUNDLE • ${this.dataset.price}` : 'BUNDLE CHECKOUT IN TESTING';
  }
  async submit() {
    if (this.busy || this.total() !== this.count || this.dataset.enabled !== 'true') return;
    const quantities = this.inputs.map(x => Number(x.value));
    if (quantities.some(q => !Number.isInteger(q) || q < 0)) return;
    const id = this.map[quantities.join(',')];
    if (!id) { this.status.textContent = 'This combination is unavailable. Please choose another mix.'; return; }
    this.busy = true; this.status.textContent = ''; this.render();
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: 1 }] })
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || 'Unable to add this bundle. Please try again.');
      window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
    } catch (error) {
      this.status.textContent = error.message || 'Unable to add this bundle. Please try again.';
      this.busy = false; this.render();
    }
  }
}
if (!customElements.get('bms-bundle-builder')) customElements.define('bms-bundle-builder', BmsBundleBuilder);
